import React, { FC } from 'react';
import { Stack } from '@mui/material';
import CustomNumberInput from '../../common/CustomNumberInput';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import CustomSelect from '../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../utils/utils';
const ProjectPeopleSection: FC = () => {
  const t = useTranslation();
  return (
    <Stack spacing={2} width={'100%'}>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.people')}
      </Text>
      <Stack direction={'row'} spacing={2}>
        <Stack sx={{ flex: 1 }}>
          <CustomNumberInput
            name={'totalNumberOfFullTimeEmployees'}
            removeK
            label={t('labels.employersNumber')}
          />
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <CustomNumberInput
            name={'totalNumberOfEmployees'}
            removeK
            label={t('labels.employersTotalNumber')}
          />
        </Stack>
      </Stack>
      <Stack direction={'row'} spacing={2}>
        <Stack sx={{ flex: 1 }}>
          <CustomSelect
            optionsArray={getOptionsFromTranslation(t, 'estimatedPeopleImpact')}
            label={t('labels.estimatedPeopleImpact')}
            name={'estimatedPeopleImpact'}
          />
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <CustomSelect
            optionsArray={getOptionsFromTranslation(
              t,
              'communicationsAndPcComplexity',
            )}
            label={t('labels.communicationsAndPcComplexity')}
            name={'communicationsAndPcComplexity'}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ProjectPeopleSection;
